<script lang="ts">
    import Step from "../common/step.component.svelte";
    import { RequirementStore } from "../../stores/requirement-store";
    import { html2pdfActionButton } from "../../actions/html2pdf";
    import { appstates } from "../../stores/app-state";
    import ActionsTable from "../main/actions/actions-table.component.svelte";

    // Export
    export let title: string = "";

    let nextEnable = false;
</script>

<Step {title} {nextEnable} imageIndex={$appstates}>
    <span slot="presentation">
        Merci pour votre temps ! Vous trouverez ci-dessous un rappel de votre
        saisie et un moyen (normalement) de l'exporter. Cela peut servir de base
        au démarrage de votre projet.
    </span>
    <span slot="content" >
        <div id="pdf">
            <h1>{$RequirementStore.info?.title}</h1>
            <p>
                {$RequirementStore.info.description}
            </p>
            {#if $RequirementStore.stakes.length > 0}
                <h2>Enjeux</h2>
                <ul>
                    {#each $RequirementStore.stakes as item}
                        <li>{item}</li>
                    {/each}
                </ul>
            {/if}
            {#if $RequirementStore.actors.length > 0}
                <h2>Acteurs</h2>
                <ul class="simple">
                    {#each $RequirementStore.actors as item}
                        <li>{item}</li>
                    {/each}
                </ul>
            {/if}
            {#if $RequirementStore.datas.length > 0}
                <h2>Données</h2>
                <ul class="simple">
                    {#each $RequirementStore.datas as item}
                        <li>{item}</li>
                    {/each}
                </ul>
            {/if}
            {#if $RequirementStore.actions.length > 0}
                <h2>Actions</h2>
                <ActionsTable
                    actions={$RequirementStore.actions}
                    readonly={true}
                />
            {/if}
            {#if $RequirementStore.questions.length > 0}
                <h2>Questions</h2>
                <ul>
                    {#each $RequirementStore.questions as item}
                        <li>
                            {item.label} :
                            <span class="answer"> {item.answer} </span>
                        </li>
                    {/each}
                </ul>
            {/if}
            <div style="text-align:center" >
                <button use:html2pdfActionButton={"pdf"}  > Export PDF </button>
            </div>
        </div>
    </span>
</Step>

<style>
    ul.simple {
        columns: 2;
        -webkit-columns: 2;
        -moz-columns: 2;
    }

    li {
        padding-bottom: 5px;
    }

    .answer {
        color: var(--primary-color);
        font-weight: bold;
    }
</style>
